const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxOTczLCJjb25ncmVzc0lkIjoxNDU1LCJkYXRlIjoiMjAyMy0wOC0xNVQxMDo1MzozMS42MTNaIiwiaWF0IjoxNjkyMDk2ODExfQ.oDVc0EzH40dbRIzNIcNZi0ZO3xvuAIQp50Cxn7MAsjM';
const PLANNER_API_URL = 'https://sgaimfk2024.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxOTc0LCJjb25ncmVzc0lkIjoxNDU1LCJkYXRlIjoiMjAyMy0wOC0xNVQxMDo1Mzo1OS42NzZaIiwiaWF0IjoxNjkyMDk2ODM5fQ.l159g1TxUfUX53PCD0RPu7hDRFaOmapFxBjkf5CYvqg';
// const PLANNER_API_URL = 'http://127.0.0.1:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1455;
// const SUBMISSION_SYSTEM_URL = 'https://sgaimfk2024.abstract.documedias.systems/api/v1/export/transformed/filtered/single/abstract/{{id}}/planner/export';

const SUBMISSION_API_URL = 'https://sgaimfk2024.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}